import React from 'react';
import LoginForm from '../../components/shared/LoginForm';

/**
 * Admin Login Page
 * ใช้ Shared LoginForm component กับ mode="admin"
 * 
 * รองรับ:
 * - Admin login (username/password)
 * - Admin Employee login (email/password)
 * - 2FA verification
 */
const AdminLoginPage: React.FC = () => {
  return <LoginForm mode="admin" />;
};

export default AdminLoginPage;
